/**
 * Shared timezone types and constants
 */

export interface Timezone {
  value: string
  label: string
  offset: string
}

export const TIMEZONES: Timezone[] = [
  { value: 'UTC', label: 'UTC', offset: '+00:00' },
  { value: 'America/New_York', label: 'Eastern Time (ET)', offset: '-05:00' },
  { value: 'America/Chicago', label: 'Central Time (CT)', offset: '-06:00' },
  { value: 'America/Denver', label: 'Mountain Time (MT)', offset: '-07:00' },
  {
    value: 'America/Los_Angeles',
    label: 'Pacific Time (PT)',
    offset: '-08:00',
  },
  { value: 'America/Phoenix', label: 'Arizona Time', offset: '-07:00' },
  {
    value: 'Europe/London',
    label: 'Greenwich Mean Time (GMT)',
    offset: '+00:00',
  },
  {
    value: 'Europe/Paris',
    label: 'Central European Time (CET)',
    offset: '+01:00',
  },
  {
    value: 'Europe/Berlin',
    label: 'Central European Time (CET)',
    offset: '+01:00',
  },
  { value: 'Asia/Tokyo', label: 'Japan Standard Time (JST)', offset: '+09:00' },
  {
    value: 'Asia/Shanghai',
    label: 'China Standard Time (CST)',
    offset: '+08:00',
  },
  {
    value: 'Asia/Kolkata',
    label: 'India Standard Time (IST)',
    offset: '+05:30',
  },
  {
    value: 'Australia/Sydney',
    label: 'Australian Eastern Time (AET)',
    offset: '+11:00',
  },
  {
    value: 'Australia/Melbourne',
    label: 'Australian Eastern Time (AET)',
    offset: '+11:00',
  },
  {
    value: 'Pacific/Auckland',
    label: 'New Zealand Time (NZST)',
    offset: '+13:00',
  },
]
